import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-custom col-lg-6" }
const _hoisted_2 = { class: "p-field" }
const _hoisted_3 = {
  class: "p-field-label",
  for: "name"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("AppResource.Name")), 1),
      _createVNode(_component_InputText, {
        id: "name",
        type: "text",
        class: ["w-100", { 'input-error': !_ctx.isValidName }],
        modelValue: _ctx.roomObject.name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.roomObject.name = $event))
      }, null, 8, ["modelValue", "class"]),
      _createVNode("label", {
        if: !_ctx.isValidName,
        for: "name",
        class: "fs-13 label-error"
      }, _toDisplayString(_ctx.invalidNameReason), 9, ["if"])
    ]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.fieldsComponent), { roomObject: _ctx.roomObject }, null, 8, ["roomObject"]))
  ]))
}